var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isNull } from "../utils/obj-check";
import { momentTimezone } from "../utils/moment";
import moment from "moment";
import { useSelector } from "react-redux";
import { selectAppContent, selectSelfApp, selectStyles } from "@adm-media/adam-store-plugin";
var useAgenda = function () {
    var timezone = useSelector(selectSelfApp).timezone;
    var contents = useSelector(selectAppContent);
    var styles = useSelector(selectStyles);
    var formatAMPM = !!(styles === null || styles === void 0 ? void 0 : styles.agenda_datetime_am_pm);
    var formatAgenda = function (_a) {
        var _b;
        var agendaItem = _a.agendaItem;
        var start;
        if (!timezone && agendaItem.start_at)
            start = moment(agendaItem.start_at);
        else if (timezone && agendaItem.start_at)
            start = momentTimezone.utc(agendaItem.start_at).tz(timezone);
        else
            start = null;
        return __assign(__assign({}, agendaItem), { 
            // @ts-ignore Need to update start_at type in package
            children: (_b = agendaItem === null || agendaItem === void 0 ? void 0 : agendaItem.children) === null || _b === void 0 ? void 0 : _b.map(function (agendaChildren) {
                var childrenStart;
                if (!timezone && agendaChildren.start_at)
                    childrenStart = moment(agendaChildren.start_at);
                else if (timezone && agendaChildren.start_at)
                    childrenStart = momentTimezone.utc(agendaChildren.start_at).tz(timezone);
                else
                    childrenStart = null;
                return __assign(__assign({}, agendaChildren), { start_at: !childrenStart ? null : formatAMPM ? childrenStart === null || childrenStart === void 0 ? void 0 : childrenStart.format("h:mm A") : childrenStart === null || childrenStart === void 0 ? void 0 : childrenStart.format("HH:mm"), label: !isNull(agendaChildren.duration) ? "".concat(agendaChildren.duration, " ").concat(contents.minutes || "minutes") : undefined });
            }), 
            // @ts-ignore Need to update start_at type in package
            start_at: !start ? null : formatAMPM ? start === null || start === void 0 ? void 0 : start.format("h:mm A") : start === null || start === void 0 ? void 0 : start.format("HH:mm"), label: !isNull(agendaItem.duration) ? "".concat(agendaItem.duration, " ").concat(contents.minutes || "minutes") : undefined });
    };
    return { formatAgenda: formatAgenda };
};
export default useAgenda;
